import React from 'react';

/* 
  This is a component wrapper to catch UI errors. Currently, you can only do this with Class Components.
  Ref: https://reactjs.org/docs/hooks-faq.html#do-hooks-cover-all-use-cases-for-classes
*/
class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      hasError: false
    };
  }

  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }

  render() {
    const { hasError } = this.state;

    if (hasError) return;
    
    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
